<template>
	<section class="sticky-basket">

		<div v-if="open" class="top-bar">
			<button type="button" @click="toggleBlock">
				<IconClose />
			</button>

			<h2 class="title-basket">{{ basket.title }}</h2>
		</div>

		<div v-if="open" class="content">
			<BasketCard
					:basket="basket"
					:nextStep="nextStep"
					inside-sticky-basket
					@close="open = false"
			/>
		</div>

		<div class="bottom-bar">
			<div v-if="!open" class="prices">
				<div>Per maand {{ formattedTotalMonthlyPrice }}</div>
				<div class="caption">Eenmalig: {{ formattedTotalSinglePrice }}</div>
			</div>

			<div v-if="!open" class="toggle">
				<button type="button" @click="toggleBlock">
					<IconChevronDown />
				</button>
			</div>

			<div v-if="nextStep && nextStep.type" class="next-step">

				<button v-if="basket.standingChargeProductToBeSelected" class="button disabled">
					{{ nextStep.text }}
				</button>

				<template v-else>
					<button v-if="nextStep.type === 'SUBMIT'" :form="nextStep.form" class="button" type="submit">
						{{ nextStep.text }}
					</button>

					<a v-if="nextStep.type === 'LINK'" :href="nextStep.url" class="button">
						{{ nextStep.text }}
					</a>
				</template>
			</div>

		</div>
	</section>
</template>

<script lang="ts" setup>
	import type {Basket} from '@/types/basket';
	import type {NextStep} from '@/types/global-types';
	import BasketCard from '@/components/basket/BasketCard.vue';
	import IconChevronDown from '@/components/icons/IconChevronDown.vue';
	import {computed, ref} from 'vue';
	import {getFormattedPrice} from '@/utils/priceFormatter';
	import IconClose from '@/components/icons/IconClose.vue';

	const props = defineProps<{
		basket: Basket,
		nextStep: NextStep
	}>();

	const open = ref(false);

	const toggleBlock = () => open.value = !open.value;

	const totalMonthlyPrice = computed(() => props.basket.totalMonthlyCosts.find(entry => !entry.action)?.totalPrice ?? 0);
	const formattedTotalMonthlyPrice = computed(() => getFormattedPrice(totalMonthlyPrice.value));

	// TODO: DFNUPGRADE-125 - Weergave van eenmalige kosten
	const totalSinglePrice = computed(() => 0);
	const formattedTotalSinglePrice = computed(() => getFormattedPrice(totalSinglePrice.value));
</script>

<style lang="scss" scoped>

	.sticky-basket {
		max-height: 90vh;
		display: flex;
		flex-direction: column;
		justify-content: stretch;
		align-items: stretch;
	}

	.sticky-basket > * {
		flex: 0 0 auto;
		width: 100%;
	}

	.content {
		flex-shrink: 1;
		overflow: auto;
		overscroll-behavior: contain;
	}

	h2 {
		color: var(--color-primary_blue);
		font-weight: 700;
		margin: 0;
		padding: 0;
	}

	.top-bar {
		padding: 12px 24px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #e6e6e6;
	}

	.top-bar button {
		order: 2;
	}

	.bottom-bar {
		display: flex;
		flex-wrap: nowrap;
		padding: 8px 24px;
		align-items: center;
	}

	.bottom-bar .prices {
		flex: 900 0 auto;
		margin-right: auto;
	}

	.bottom-bar .toggle {
		flex: 0 0 auto;
		padding: 0 1em;
	}

	.bottom-bar .next-step {
		flex: 1 0 auto;
	}

	button:not(.button) {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: #f3f3f3;
		border: none;
		border-radius: 50%;

		width: 32px;
		height: 32px;
		margin: 0;
	}
</style>
